import React, { Fragment } from "react"
import { Popover } from "antd"
import { Icon } from "@ant-design/compatible"
import img from "../../images/emptyquestions.svg"
import EmptyButton from "../../components/EmptyButton"
import { LeftOutlined, QuestionCircleFilled } from "@ant-design/icons"
import { TYPE_SURVEY } from "../../utils/constants"

export class Empty extends React.Component {
  fileSelectedHandler = (event) => {
    const { match, uploadTemplate } = this.props
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    const objS = { file: fd, id: this.props.match.params.id }
    this.props.uploadTemplate(objS)
    this.fileInput.value = ""
  }

  renderEmptyQuestionnaireImport = () => {
    const {
      isDownloading,
      getTemplate,
      isUploading,
      match,
      surveyData,
    } = this.props

    const surveys = [
      TYPE_SURVEY.culture.idSurveyType,
      TYPE_SURVEY.welfare.idSurveyType,
      TYPE_SURVEY.internalCustomer.idSurveyType,
    ]
    const exceptionIndicator = !surveys.includes(surveyData.id_survey_type)

    const surveysOYO = [
      TYPE_SURVEY.onboarding.idSurveyType,
      TYPE_SURVEY.offboarding.idSurveyType,
    ]
    const isOYo = surveysOYO.includes(surveyData.id_survey_type)

    const titleComponent = () => {
      let response = `Carga las preguntas comprendidas en tu encuesta de ${surveyData.survey_type}, junto con las dimensiones a las que estas afectan.`
      if (exceptionIndicator && !isOYo) {
        response =
          "Carga las preguntas comprendidas en tu encuesta de clima, junto con las dimensiones a las que estas afectan."
      }

      return response
    }

    const notesComponent = () => {
      if (isOYo) {
        return null
      }

      return (
        <div>
          <p style={{ fontWeight: 400, marginBottom: "8px" }}>
            <span style={{ fontWeight: 600 }}>Nota:</span> Al importar
            dimensiones que no sean parte de nuestro cuestionario predeterminado
            de Clima y Engagement, es posible que se pierda
          </p>

          <p
            style={{
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <span style={{ fontWeight: 400 }}>
              la opción de visualizar el{" "}
              <span style={{ fontWeight: 600 }}>benchmark Mandü. </span>{" "}
            </span>
            <Popover
              placement="top"
              content={
                <div style={{ fontSize: 14 }}>
                  <p style={{ fontWeight: 400, marginBottom: "4px" }}>
                    El <span style={{ fontWeight: 600 }}>benchmark Mandü </span>
                    es un indicador que te{" "}
                  </p>
                  <p style={{ fontWeight: 400, marginBottom: "4px" }}>
                    permite comparar los resultados de tu empresa
                  </p>
                  <p style={{ fontWeight: 400, marginBottom: "4px" }}>
                    {" "}
                    frente al promedio de la industria.
                  </p>
                </div>
              }
              trigger="hover">
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  paddingLeft: "8px",
                }}
              />
            </Popover>
          </p>
        </div>
      )
    }

    return (
      <Fragment>
        <img className="import-screen-image" src={img} />
        <div className="import-screen-description">
          <p style={{ fontWeight: 600, fontSize: 16 }}>
            Importa tu cuestionario
          </p>
          <div style={{ margin: "1rem", lineHeight: "32px" }}>
            <p style={{ fontWeight: 400, marginBottom: "8px" }}>
              {titleComponent()}
            </p>
            <p style={{ fontWeight: 400, marginBottom: "8px" }}>
              <span style={{ fontWeight: 600 }}>¡Recuerda!</span> La información
              importada se agregará a las preguntas creadas anteriormente, si es
              que las hubieran.
            </p>
            {exceptionIndicator && notesComponent()}
          </div>
        </div>
        <div className="import-screen-instructions">
          <span style={{ marginBottom: "10px", fontWeight: 600 }}>
            Instrucciones:
          </span>
          <p
            style={{
              marginLeft: "1rem",
              marginRight: "1rem",
              lineHeight: "40px",
            }}>
            1. Descarga la plantilla de Excel.
            <br />
            2. Llena los campos con las preguntas, dimensiones y subdimensiones
            de tu cuestionario.
            <br />
            3. Importa el Excel con la información.
            <br />
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifySelf: "center",
            marginTop: "2rem",
          }}>
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={isDownloading}
            onClick={() =>
              getTemplate({
                template: true,
                id: match.params.id,
              })
            }
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={isUploading}
            label="Importar cuestionario"
            style={{ marginLeft: "2rem" }}
          />
          <input
            id="import"
            style={{ display: "none" }}
            type="file"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </div>
      </Fragment>
    )
  }

  renderEmptyImportingNewQuestions = () => {
    const { isDownloading, getTemplate, isUploading, match } = this.props
    return (
      <Fragment>
        <img className="import-screen-image" src={img} />
        <div className="import-screen-description">
          <p style={{ fontWeight: 600, fontSize: 16 }}>
            Importa tu cuestionario
          </p>
          <div style={{ margin: "1rem", lineHeight: "32px" }}>
            <span style={{ fontWeight: 400 }}>
              Carga <strong style={{ fontWeight: 600 }}>nuevas</strong>{" "}
              preguntas a tu encuesta. La información importada se{" "}
              <strong style={{ fontWeight: 600 }}>agregará</strong> a las
              preguntas ya existentes.
            </span>
            <br />
            <span style={{ fontWeight: 400 }}>
              <strong style={{ fontWeight: 600 }}>¡Recuerda!</strong> No es
              posible <strong style={{ fontWeight: 600 }}>editar</strong>{" "}
              elementos ya existentes en el cuestionario a través de este
              importable.
            </span>
          </div>
        </div>
        <div className="import-screen-instructions">
          <span style={{ marginBottom: "10px", fontWeight: 600 }}>
            Instrucciones:
          </span>
          <p
            style={{
              marginLeft: "1rem",
              marginRight: "1rem",
              lineHeight: "40px",
            }}>
            1. Descarga la plantilla de Excel.
            <br />
            2. Llena los campos con las preguntas, dimensiones y subdimensiones
            de tu cuestionario.
            <br />
            3. Importa el Excel con la información.
            <br />
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifySelf: "center",
            marginTop: "2rem",
          }}>
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={isDownloading}
            onClick={() =>
              getTemplate({
                template: true,
                id: match.params.id,
              })
            }
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={isUploading}
            label="Importar nuevas preguntas"
            style={{ marginLeft: "2rem" }}
          />
          <input
            id="import"
            style={{ display: "none" }}
            type="file"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </div>
      </Fragment>
    )
  }

  render() {
    const { history, isData } = this.props
    return (
      <div>
        <div
          className="btnBack"
          style={{ padding: "1rem 1rem" }}
          onClick={() => history.goBack()}>
          <LeftOutlined />
          Cuestionario
        </div>
        <div className="import-screen">
          {isData
            ? this.renderEmptyImportingNewQuestions()
            : this.renderEmptyQuestionnaireImport()}
        </div>
      </div>
    )
  }
}
